import Vue from 'vue'
import vSelect from 'vue-select'
import '../../static-appopensalud/css/vendor/v-select.scss'

Vue.component('v-select', vSelect)



// WEBPACK FOOTER //
// ./src/plugins/vue-select.js